import React from "react";
import styled from "styled-components";

import { EstimationCommentForCompilation } from "./types";
import { formatTimestamp } from "./utils";
import { UsableComment } from "./shared-components";

interface Props {
  comment: EstimationCommentForCompilation;
  used: boolean;
  use: () => void;
  usedHidden: boolean;
}

function EstimationComment(props: Props) {
  const {
    comment: { activityCode, commentType, content, createdBy, createdDateTime },
    used,
    use,
    usedHidden,
  } = props;
  return (
    <UsableComment used={used} usedHidden={usedHidden} use={use}>
      <CommentSubtitle>
        <Commenter>{createdBy}</Commenter>
        <CommentDate>{formatTimestamp(createdDateTime)}</CommentDate>
      </CommentSubtitle>
      <CommentHeader>
        <CommentTypeDesc>{activityCode}</CommentTypeDesc>
        <CommentTypeDesc>{commentType}</CommentTypeDesc>
      </CommentHeader>
      <CommentText>{content}</CommentText>
    </UsableComment>
  );
}

export default EstimationComment;

const CommentSubtitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 10px;
  font-weight: normal;
`;

const Commenter = styled.div`
  display: flex;
`;

const CommentDate = styled.div`
  display: flex;
`;

const CommentHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: bold;
  margin-bottom: 12px;
`;

const CommentTypeDesc = styled.div`
  display: flex;
  font-size: 14px;
`;

const CommentText = styled.div`
  font-size: 12px;
  white-space: normal;
  font-weight: normal;
`;
